<div class="medibrix-modal-bg" *ngIf="isVisible" (pointerdown)="onModalBackgroundClick($event)">
  <div
    class="medibrix-modal"
    (pointerdown)="$event.stopPropagation()"
    [ngStyle]="{
      fontFamily: printerQueue?.fontFamily
    }"
    (touchstart)="$event.preventDefault(); $event.stopPropagation()"
    (touchend)="$event.preventDefault(); $event.stopPropagation()"
  >
    <div *ngIf="currentStep === STEPS.INITIAL" class="modal-content initial-step">
      <div class="initial-step-content">
        <span
          class="button-label"
          [ngStyle]="{
            color: printerQueue?.labelColor
          }"
        >
          {{ 'booking_haveYouBooked' | translate : branchService.details.locale }}
        </span>
        <button
          type="button"
          (pointerdown)="onHaveBookingCodeClick(); $event.preventDefault(); $event.stopPropagation()"
          (click)="$event.preventDefault(); $event.stopPropagation()"
          [disabled]="isTransitioning"
          [ngStyle]="{
            color: printerQueue?.buttonTextColor,
            background: printerQueue?.buttonBackgroundColor
          }"
        >
          {{ 'booking_yesHaveBooked' | translate : branchService.details.locale }}
        </button>
        <button
          type="button"
          (pointerdown)="onDropInClick(); $event.preventDefault(); $event.stopPropagation()"
          (click)="$event.preventDefault(); $event.stopPropagation()"
          [disabled]="isTransitioning"
          [ngStyle]="{
            color: printerQueue?.buttonBackgroundColor,
            background: printerQueue?.buttonTextColor,
            borderColor: printerQueue?.buttonBackgroundColor
          }"
        >
          {{ 'booking_noHaveBooked' | translate : branchService.details.locale }}
        </button>
      </div>
    </div>

    <div *ngIf="currentStep === STEPS.BOOKING_CODE" class="modal-content check-in-code-step">
      <form [formGroup]="bookingCodeForm" class="booking-form">
        <span
          class="button-label"
          [ngStyle]="{
            color: printerQueue?.labelColor
          }"
        >
          {{ 'booking_inputCheckInCode' | translate : branchService.details.locale }}
        </span>
        <div class="input-message-wrapper">
          <input
            #bookingCodeInput
            type="text"
            class="form-control booking-input"
            formControlName="bookingCode"
            maxlength="6"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]*"
            [readonly]="showKeypad"
            [placeholder]="'booking_inputCheckInPlaceholder' | translate : branchService.details.locale"
          />
          <div *ngIf="bookingError" class="invalid-message">
            {{ bookingError | translate : branchService.details.locale }}
          </div>
          <div *ngIf="isLoading" class="spinner-wrapper">
            <div class="spinner"></div>
          </div>
        </div>

        <div
          *ngIf="showKeypad"
          class="keypad"
          (click)="$event.preventDefault(); $event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          (touchstart)="$event.preventDefault(); $event.stopPropagation()"
          (touchend)="$event.preventDefault(); $event.stopPropagation()"
          (pointerup)="$event.preventDefault(); $event.stopPropagation()"
        >
          <div class="keypad-row">
            <div
              class="key"
              [ngStyle]="{ color: printerQueue?.labelColor }"
              *ngFor="let d of ['1', '2', '3']"
              (pointerdown)="onDigitPress(d); $event.preventDefault(); $event.stopPropagation()"
              (click)="$event.preventDefault(); $event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (touchstart)="$event.preventDefault(); $event.stopPropagation()"
              (touchend)="$event.preventDefault(); $event.stopPropagation()"
              (pointerup)="$event.preventDefault(); $event.stopPropagation()"
            >
              {{ d }}
            </div>
          </div>
          <div class="keypad-row">
            <div
              class="key"
              [ngStyle]="{ color: printerQueue?.labelColor }"
              *ngFor="let d of ['4', '5', '6']"
              (pointerdown)="onDigitPress(d); $event.preventDefault(); $event.stopPropagation()"
              (click)="$event.preventDefault(); $event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (touchstart)="$event.preventDefault(); $event.stopPropagation()"
              (touchend)="$event.preventDefault(); $event.stopPropagation()"
              (pointerup)="$event.preventDefault(); $event.stopPropagation()"
            >
              {{ d }}
            </div>
          </div>
          <div class="keypad-row">
            <div
              class="key"
              [ngStyle]="{ color: printerQueue?.labelColor }"
              *ngFor="let d of ['7', '8', '9']"
              (pointerdown)="onDigitPress(d); $event.preventDefault(); $event.stopPropagation()"
              (click)="$event.preventDefault(); $event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (touchstart)="$event.preventDefault(); $event.stopPropagation()"
              (touchend)="$event.preventDefault(); $event.stopPropagation()"
              (pointerup)="$event.preventDefault(); $event.stopPropagation()"
            >
              {{ d }}
            </div>
          </div>
          <div class="keypad-row">
            <div
              class="key action back-arrow"
              [ngStyle]="{ color: printerQueue?.labelColor }"
              (pointerdown)="onDeleteDigit(); $event.preventDefault(); $event.stopPropagation()"
              (click)="$event.preventDefault(); $event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (touchstart)="$event.preventDefault(); $event.stopPropagation()"
              (touchend)="$event.preventDefault(); $event.stopPropagation()"
              (pointerup)="$event.preventDefault(); $event.stopPropagation()"
            >
              <span class="icon-arrow"></span>
            </div>
            <div
              class="key"
              [ngStyle]="{ color: printerQueue?.labelColor }"
              (pointerdown)="onDigitPress('0'); $event.preventDefault(); $event.stopPropagation()"
              (click)="$event.preventDefault(); $event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (touchstart)="$event.preventDefault(); $event.stopPropagation()"
              (touchend)="$event.preventDefault(); $event.stopPropagation()"
              (pointerup)="$event.preventDefault(); $event.stopPropagation()"
            >
              0
            </div>
            <div
              class="key action reset"
              [ngStyle]="{ color: printerQueue?.labelColor }"
              (pointerdown)="clearAll(); $event.preventDefault(); $event.stopPropagation()"
              (click)="$event.preventDefault(); $event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (touchstart)="$event.preventDefault(); $event.stopPropagation()"
              (touchend)="$event.preventDefault(); $event.stopPropagation()"
              (pointerup)="$event.preventDefault(); $event.stopPropagation()"
            >
              C
            </div>
          </div>
        </div>

        <div class="button-row">
          <button
            type="submit"
            [disabled]="isTransitioning"
            [ngStyle]="{
              color: printerQueue?.buttonTextColor,
              background: printerQueue?.buttonBackgroundColor
            }"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            (touchstart)="$event.preventDefault(); $event.stopPropagation()"
            (touchend)="$event.preventDefault(); $event.stopPropagation()"
            (pointerup)="$event.preventDefault(); $event.stopPropagation()"
            (pointerdown)="onConfirmBookingCode(); $event.preventDefault(); $event.stopPropagation()"
          >
            {{ 'ok' | translate : branchService.details.locale }}
          </button>
          <button
            type="button"
            (pointerdown)="onBackClick(); $event.preventDefault(); $event.stopPropagation()"
            (click)="$event.preventDefault(); $event.stopPropagation()"
            [disabled]="isTransitioning"
            [ngStyle]="{
              color: printerQueue?.buttonBackgroundColor,
              background: printerQueue?.buttonTextColor,
              borderColor: printerQueue?.buttonBackgroundColor
            }"
          >
            {{ 'back' | translate : branchService.details.locale }}
          </button>
        </div>
      </form>
    </div>

    <button
      type="button"
      class="close-btn"
      (pointerdown)="closeModal(); $event.preventDefault(); $event.stopPropagation()"
      (click)="$event.preventDefault(); $event.stopPropagation()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
      {{ 'close' | translate : branchService.details.locale }}
    </button>
  </div>
</div>
